import { add, format, isValid, parse } from "date-fns";

export const calculateEndTime = (start, duration) => {
    const startTime = parse(start, 'HH:mm', new Date());
    const [durationHours, durationMinutes] = duration.split(':').map(Number);
    const durationObj = { hours: durationHours, minutes: durationMinutes };
    const endTime = add(startTime, durationObj);

    if (!isValid(endTime)) {
        return 'N/A:N/A';
    }
    return format(endTime, 'HH:mm');
};


export const calculateDuration = (duration) => {
    const [totalHours, minutes] = duration.split(':').map(Number);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    return { days, hours, minutes };
};

